

//----------------------------------------------- CourseLayoutEditor ------------------------------------------------------------------------------

import React from 'react';
import { useAuth } from '../../../lib/auth-context';
import { CourseLayoutEditor } from '../../../components/course/CourseLayoutEditor';
import GenericCourseContainer from '../../../components/course/GenericCourseContainer';
import { courseStructure } from './course-structure';

// Importation des contenus de chapitres
import Chapitre1Content from './chapitres/Chapitre1Content';
import Chapitre2Content from './chapitres/Chapitre2Content';
import Chapitre3Content from './chapitres/Chapitre3Content';
import Chapitre4Content from './chapitres/Chapitre4Content';
// Mappings des composants de contenu par ID de chapitre
const chapterContents = {
  'chapitre1': Chapitre1Content,
  'chapitre2': Chapitre2Content,
  'chapitre3': Chapitre3Content,
  'chapitre4': Chapitre4Content,
};

// Code initial pour le jeu
const initialCode = `// Jeu 1 : Améliore ta visée
`;

const CourseContainer = () => {
  const { currentUser } = useAuth();
  
  // Props spécifiques à CourseLayoutEditor
  const editorLayoutProps = {
    initialCode: initialCode,
    projectId: `ameliorevisée_editor`,
    workdir:``
  };
  
  return (
    <GenericCourseContainer
      courseStructure={courseStructure}
      chapterContents={chapterContents}
      LayoutComponent={CourseLayoutEditor}
      layoutProps={editorLayoutProps}
    />
  );
};

export default CourseContainer; 